export default __webpack_public_path__ + "static/media/conte.ce9ed5cc.jpg";